var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.375L9.5 10.625M9.5 3.875L5 6.125M11.75 14C10.5074 14 9.5 12.9926 9.5 11.75C9.5 10.5074 10.5074 9.5 11.75 9.5C12.9926 9.5 14 10.5074 14 11.75C14 12.9926 12.9926 14 11.75 14ZM2.75 9.5C1.50736 9.5 0.5 8.49264 0.5 7.25C0.5 6.00736 1.50736 5 2.75 5C3.99264 5 5 6.00736 5 7.25C5 8.49264 3.99264 9.5 2.75 9.5ZM11.75 5C10.5074 5 9.5 3.99264 9.5 2.75C9.5 1.50736 10.5074 0.5 11.75 0.5C12.9926 0.5 14 1.50736 14 2.75C14 3.99264 12.9926 5 11.75 5Z",
    stroke: "#BF3F04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.863609fc9811af6549c5c2c52a60d34e.svg";
export { ForwardRef as ReactComponent };